import React, { useEffect } from 'react'
import QueueAnim from 'rc-queue-anim'
import Button from '@material-ui/core/Button'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import messages from 'routes/Exception/translate'
import * as ROUTE from 'constants/appRouting'
import { setAccessDenied } from 'reducers/layout/reducer'
import { REACT_INTL_PROP_TYPE } from 'constants/propTypes'

function Error404({ formatMessage }) {
  return (
    <div className="err-container text-center">
      <div className="err">
        <h1>403</h1>
        <h2>{formatMessage(messages.accessDeniedMessage)}</h2>
      </div>

      <div className="err-body">
        <Button href={ROUTE.APPS} variant="contained">
          {' '}
          {formatMessage(messages.accessGoBack)}{' '}
        </Button>
      </div>
    </div>
  )
}

Error404.propTypes = {
  formatMessage: PropTypes.func.isRequired,
}

function Page({ intl: { formatMessage } }) {
  useEffect(() => {
    setAccessDenied(false)
  }, [])

  return (
    <div className="page-err">
      <QueueAnim type="bottom" className="ui-animate">
        <div key="1">
          <Error404 formatMessage={formatMessage} />
        </div>
      </QueueAnim>
    </div>
  )
}

Page.propTypes = {
  intl: REACT_INTL_PROP_TYPE.isRequired,
}
export default connect(null, { setAccessDenied })(injectIntl(Page))
